import React from "react";
import * as Sentry from "@sentry/react";
import ErrorPage from "./errorPage";
const isDev = import.meta.env.DEV || false;

export default class GlobalErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // Send to Sentry here if you like
        Sentry.withScope((scope) => {
            scope.setExtra("componentStack", info?.componentStack);
            scope.setTag("boundary", "GlobalErrorBoundary");
            Sentry.captureException(error);
        });
        console.error("GlobalErrorBoundary caught:", error, info);
    }
    render() {
        if (this.state.hasError) {
            return (<ErrorPage>{isDev ?
                <>
                    <h2>Global</h2>
                </> : <></>

            }</ErrorPage>);
        }
        return this.props.children;
    }
}
